import { Component, Input } from '@angular/core';

import { Subscription } from 'rxjs';

import { VideogularComponent } from '@vbrick/vbrick-player/app/player/videogular/Videogular.Component';

import { SecondMs } from 'rev-shared/date/Time.Constant';
import { SimpleToolbar } from 'rev-shared/htmlEditor/Constants';

import { VideoReviewService } from './VideoReview.Service';

import styles from './VideoReview.module.less';

@Component({
	selector: 'video-review-manual-comment-input',
	host: { '[class]': 'styles.manualCommentInputRoot' },
	template: `
		<div [ngClass]="styles.includeTimestampWrapper">
			<span>
				{{ 'IncludeTimestamp' | translate }}&nbsp;
				(&nbsp;{{ (timestamp !== null ? timestamp : currentTime) | vbTimespan : showHoursInTimestamp : true }}&nbsp;)
			</span>
			<vb-ui-checkbox
				name="includeTimestamp"
				class="margin-left-10"
				[accessibilityLabel]="'IncludeTimestamp' | translate"
				[(ngModel)]="includeTimestamp"
				(ngModelChange)="onIncludeTimestampChanged()">
			</vb-ui-checkbox>
			<span
				class="glyphicons circle_info margin-left-5"
				tabindex="0"
				[attr.aria-label]="'ApprovalProcess_AI_ContentAnalysis_Timestamp_Tooltip' | translate"
				[tooltip]="'ApprovalProcess_AI_ContentAnalysis_Timestamp_Tooltip' | translate"
				[placement]="'top'">
			</span>
		</div>
		<vb-ui-html-editor
			name="manualCommentEditorText"
			#htmlEditor
			#manualCommentTextModel="ngModel"
			[attr.aria-label]="'Media_Videos_Comments_AddComment' | translate"
			[(ngModel)]="manualCommentText"
			[editorConfig]="{ toolbar: SimpleToolbar, height: 70, resize_enabled: false }"
			[vbMaxLength]="MaxCommentLength"
		></vb-ui-html-editor>

		<div [ngClass]="styles.manualCommentBtnsWrapper">
			<span>{{ 'ApprovalProcess_AI_ContentAnalysis_CommentMsg' | translate }}</span>
			<button
				type="button"
				[disabled]="manualCommentTextModel.invalid"
				vbBtnPrimary
				(click)="onManualCommentSubmit()"
			>
				<span>{{ 'Post' | translate }}</span>
			</button>
		</div>

		<div *ngIf="manualCommentTextModel.invalid" role="alert" vbUiErrorMessage>
			<div *ngIf="manualCommentTextModel.errors.vbMaxLength">{{ 'CommentExceedsMaxLength' | translate : { '0' : MaxCommentLength } }}</div>
		</div>
	`
})
export class VideoReviewManualCommentInputComponent {
	@Input() public showHoursInTimestamp: boolean;
	@Input() public currentTime: number;
	@Input() public videoId: string;
	@Input() public currentApprovalStepId: string;
	@Input() public vgApi: VideogularComponent;

	public readonly styles = styles;
	public readonly SimpleToolbar = SimpleToolbar;
	public readonly MaxCommentLength = 250;

	public manualCommentText: string = '';
	public timestamp: number = null;
	public includeTimestamp: boolean = false;
	public seekEventSub: Subscription;

	constructor(
		public VideoReviewService: VideoReviewService
	) { }

	public ngOnInit(): void {
		this.seekEventSub = this.vgApi.vgSeeked.subscribe(({ $currentTime }) => {
			if (this.includeTimestamp) {
				this.timestamp = $currentTime * SecondMs;
			}
		});
	}

	public ngOnDestroy(): void {
		this.seekEventSub?.unsubscribe();
	}

	public onManualCommentSubmit(): void {
		if (!this.manualCommentText) { return; }

		this.VideoReviewService.addManualComment(
			this.videoId,
			this.currentApprovalStepId,
			this.includeTimestamp ? this.timestamp : null,
			this.manualCommentText
		).then(() => {
			this.resetModel();
		});
	}

	public onIncludeTimestampChanged(): void {
		this.timestamp = this.includeTimestamp && this.currentTime !== null ? this.currentTime : null;
	}

	public resetModel(): void {
		this.manualCommentText = '';
		this.includeTimestamp = false;
		this.timestamp = null;
	}
}
